import { useEffect, useState } from "react";
import axios from "axios";
import {h2Unlinked, castCard} from"./core/core";
import { apiRoot } from "./core/defines";
import SideNav from "./components/sideNav";

import useCastEffect from "./service/useCastData";

function NewFace(){

        const [casts, setCasts] = useState([])
        const {fetchCasts}=useCastEffect()
    
        useEffect(()=>{
    
            const init=async()=>{

                const c = await fetchCasts({newface:true})
                setCasts(c.data)
    
            }
    
            init()
            
        },[]);
    

    return(
        <div className="container bg-w-alpha">
            <section className="main-colmn">
                {h2Unlinked("NEW FACE")}
                <ul class="wrapper-sc">
                    {casts.map((cast) => 
                        <li className="card-cast" key={cast.c_id}>
                            {castCard(cast)}
                        </li>
                    )}
                </ul>

            </section>
            <SideNav />
        </div>
    )
}


export default NewFace